<template>
      <div class="flex">
         <a :href="backUrl" class="link back"><i class="icon-angle-left"></i><span>{{molang('dpp.propertyNav.search')}}</span></a>
      </div>
 </template>

 <script src="./dpp-nav.js"></script>

<style lang="scss">
   @use "./dpp-nav.scss" as *;
</style>
